import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Couponsection } from 'src/app/model/couponsection.model';
import { CouponsectionService } from 'src/app/services/couponsection.service';
import { DateService } from 'src/app/services/date.service';
import { DatePipe } from '@angular/common';
import { RemovemodalcouponComponent } from 'src/app/modal/remove-modal-coupon/remove-modal-coupon.component';

@Component({
  standalone: false,
  selector: 'app-coupon-details',
  templateUrl: './coupon-details.component.html',
  styleUrls: ['./coupon-details.component.scss']
})
export class CouponDetailsComponent implements OnInit {

  public couponsection = new Couponsection();
  private subscriptions = new Subscription();

  couponId: any;
  couponDetails: any;
  groupId: string = null;
  fromDetailsPage: any;
  checkedOnlyUsersList: any;
  couponlogo = 'couponlogo';
  tempDate: any;
  singleCouponId = [];
  fromListPage = 'no';

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private couponsectionService: CouponsectionService,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    public datepipe: DatePipe,
    private ngbCalendar: NgbCalendar,
    private route: ActivatedRoute,
  ) {
    localStorage.setItem('expandNavCreateview', 'true');
  }

  ngOnInit(): void {
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.route.params.subscribe((params) => {
      this.couponId = params['id'];
    });

    this.getCouponDetails();

  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavUser');
    this.subscriptions.unsubscribe();
  }

  openModal(couponId: string, fromListPage: any): void {

    this.singleCouponId.push(couponId);

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalcouponComponent, modalOptions);
    modalRef.componentInstance.couponId = this.singleCouponId;
    modalRef.componentInstance.fromListPage = fromListPage;
  }

  getCouponDetails() {
    this.couponsectionService.getCuoponDetails(this.couponId).subscribe((res) => {
      if (res?.isValid === true) {
        this.couponDetails = res;
        this.checkedOnlyUsersList = [];
        this.checkedOnlyUsersList.push(this.couponDetails.data);
        console.log(this.checkedOnlyUsersList);
      }
    });
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type

    }
  }

  goToEditPage(id) {
    this.router.navigate(['/update-coupon/' + id]);
  }

}
